import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Form from '../../../common/Form';
import Checkbox from '../../../common/Form/Checkbox';
import { closeModalAction } from '../../../actions/modal';
import { removeBulkAgent } from '../../../actions/service_request';
import { TicketAgentRole } from '../TicketController';

// Shares its form name with the bulk action so the confirm button picks up the same loading flag.
export const removeClusterAndPspFormName = 'removeAgent';

// Both roles are removed by the same endpoint, so the modal just picks which of them to send.
export const RemoveClusterAndPsp = ({ ticketIds = [] }) => {
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    const methods = useForm({ defaultValues: { cluster: true, psp: true }, mode: 'all' });
    const { cluster, psp } = methods.watch();
    const hasRoleSelected = cluster || psp;

    const submit = ({ cluster, psp }) => {
        const roles = [];
        if (cluster) roles.push(TicketAgentRole.CLUSTER);
        if (psp) roles.push(TicketAgentRole.PSP);
        dispatch(removeBulkAgent({ formName: removeClusterAndPspFormName, ticket_ids: ticketIds, roles }));
    };

    return (
        <Form
            methods={methods}
            onSubmit={submit}
            submitButtonText='Remove'
            onCancel={() => dispatch(closeModalAction())}
            showSubmit
            submitContainerClassName='flex gap-4 justify-end py-4 px-6 border-t border-gray-200'
            isLoading={formButtonLoading[removeClusterAndPspFormName]}
            isSubmitDisabled={ticketIds.length === 0 || !hasRoleSelected}
            submitButtonHoverText={hasRoleSelected ? '' : 'Select Cluster or PSP'}
        >
            <div className='px-6 py-4'>
                <p className='text-font12 text-black'>
                    Are you sure you want to remove the selected roles from{' '}
                    <span className='font-medium'>{ticketIds.length > 1 ? `${ticketIds.length} tickets` : 'this ticket'}</span> ?
                </p>
                <div className='flex items-center gap-6 mt-2'>
                    <Checkbox id='remove_cluster' name='cluster' label='Cluster' />
                    <Checkbox id='remove_psp' name='psp' label='PSP' />
                </div>
            </div>
        </Form>
    );
};

export default RemoveClusterAndPsp;
